__turbopack_context__.v({
  "drag": "FileUploadPlaceholderDragged-module-scss-module__ITGZpW__drag",
  "image": "FileUploadPlaceholderDragged-module-scss-module__ITGZpW__image",
});
